<template>
<div style="display:inline-block">
    <el-button size="medium" round @click="exportshop">{{rawtitle}}</el-button>
    <modalreal :zIndexEdit='false' :width='500' :height='300' v-if="showmodal">
      <div slot="title">
        {{mode.key}}
      </div>
      <div style="flex:1" slot="contner">
        <div class="grid-content content-margin">
            <div class="result" v-if="progress>=100">
                
            </div>
            <div style="width:95%;overflow:hidden" v-if="!errMsg.error"><span> {{mode.key}}进度：</span><el-progress :stroke-width="18" :text-inside="true" :percentage="progress" status="success"></el-progress></div>
            <div v-else>{{errMsg.message}}</div>
            <slot name="downloadReport"></slot>
        </div>
      </div>
      <div class="footer" slot="foter">
        <el-button @click="cancleProgress" size="mini" v-if="progress<100&&mode.flag==1">取消{{mode.key}}</el-button>
        <el-button @click="showmodal=false;handleKey=null;progress=0;completed=false" size="mini" >关闭</el-button>
        <el-button @click="downReport" type="primary" size="mini" v-if="progress>=100&&mode.flag==1&&!errMsg.error">下载 {{mode.key}}报告</el-button>
      </div>
    </modalreal>
</div>

</template>

<script>
  import { rejecthttp, changeflagCLOSED } from "@/utils/request";
  import modalreal from '@/components/modalCom/modalreal'
  import store from '@/store/index.js'

export default {
    name:'exportFile',
    components: { modalreal },
    props:{
      rawtitle:{
          type:String,
          default:'导出'
      },
        url:{
            type:String,
            default:'/manage/shop/exportshoplist'
        },
        methods:{
            type:String,
            default:'get'
        },
        sendData:{
          type:Object,
          default:{
        appID:188,
        filterConfig:{
          keyword:'',
          filterType: 0,
          keyword: "",
          name: "",
          shopNo: null
        },
        pageConfig:{
          page:1,
          pagesize:10,
          pageStartIndex:0,
        },
        sortConfig:{
          order:'',
          prop:''
        }
      }
        },
        pageSize:{
          type:Number,
          default:999999999
        },
        // downloadFileurl:{
        //     type:String,
        //     default:'/manage/shop/importshopreport?appid=188'
        // },
        // downloadFileMethods:{
        //     type:String,
        //     default:'post'
        // },
        dataHandler:{
            type:Function,
            default:(f)=>{
                let c=new FormData()
                c.append('file',f)
                return c
            }
        },
        downloadReportHandler:{
            type:Function,
            default:(that)=>{
              console.log(that)
                // var a=document.createElement('a')
                // a.href='/manage/shop/importshopreport?appid=188'
                fetch(that.urlList[that.type].downReportUrl+`?handlekey=${that.handleKey}`,{
                    method:'get',
                    credentials:'include',

                    headers:new Headers({
                        DMFSession:store.state.DMFSession
                    })
                }).then(res=>res.blob())
                .then(data=>{
                    const bloburl=window.URL.createObjectURL(data)
                    const a=document.createElement('a')
                    a.download=new Date().getTime().toString()+'.zip'
                    a.href=bloburl
                    a.click()
                })

            }
        },
        type:{
          type:Number,
          // 0 csv普通文件。1 大csv文件导入。2 取消excel文件导入。3 特殊david
          default:0
        },
        mode:{
          type:Object,
          default:()=>{
            return {
            flag:1,
            key:'导出'
          }
          }
        }
    },
    data(){
        return {
            showmodal:false,
            report:null,
            progress:0,
            intervalfunc:null,
            handleKey:null,
            // isdown
            completed:false,
            urlList:[
              {
              cancleurl:'/rs/exportfile/csvcancel',
              progressurl:'/rs/exportfile/csvprogress',
              downReportUrl:'/rs/exportfile/csvdownload'
              },
              {
              cancleurl:'/rs/exportfile/bigcsvcancel',
              progressurl:'/rs/exportfile/bigcsvprogress',
              downReportUrl:'/rs/exportfile/bigcsvdownload'

              },
              {
              cancleurl:'/rs/exportfile/excelcancel',
              progressurl:'/rs/exportfile/excelprogress',
              downReportUrl:'/rs/exportfile/exceldownload'
              },
              {
              cancleurl:'/rs/exportfile/bigcsvcancel',
              progressurl:'/rs/exportfile/runnableprogress',
              downReportUrl:'/rs/exportfile/bigcsvdownload'
              },
            ],
            errMsg:{
              error:false,
              message:''
            }
        }
    },
    methods:{
    downReport(){
        this.showmodal=false
        this.downloadReportHandler(this)
    },
    exportshop(){
      // input.onchange=(e)=>{
      //   console.log(input.files)
      //   let c=this.dataHandler(input.files[0])
      if(!this.handleKey){
        this.progress=0
        this.showmodal=true
        rejecthttp(true,this.methods,this.url,{...this.sendData,pageConfig:{
          page:1,
          pagesize:this.pageSize,
          pageStartIndex:0,
          }},this,(doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
          //   this.$message({
          //   type: "info",
          //   message: "员工导出接口ok",
          // });
          console.log(doc.data.data)
            // setTimeout(()=>{
            //   this.progress=100
            // },10000)
            this.handleKey=doc.data.data
            console.log(this.handleKey)
            this.handlerProgress()
            // this.report=doc.data.data
            this.$emit('exportSucess',doc.data.data)

          }
        }
      );
      }else{
        this.showmodal=true

      }

      // }

    },
    // 获取进度条
    handlerProgress(){
      // 暂时用定时器来做
      clearInterval(this.intervalfunc)

      this.progress=0
      this.intervalfunc=setInterval(()=>{
        var url=this.urlList[this.type].progressurl
          let r=rejecthttp(false,'get',url+'?handlekey='+this.handleKey,{},this,(doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            // setTimeout(()=>{
            //   this.progress=100
            let vrt=(doc.data.data.progress*100/(doc.data.data.total?doc.data.data.total:1)).toFixed(2)-0
            this.progress=this.progress>vrt?this.progress:vrt
            this.progress=this.progress>100?100:this.progress
            if(doc.data.data.isEnd){
              clearInterval(this.intervalfunc)
            this.progress=100
              this.completed=true
              // this.handleKey=null
            }
            if(doc.data.data.data=='FAIL'){
              this.errMsg.error=true
              this.errMsg.message=doc.data.data.message
            }
            // },10000)

          }else{
            clearInterval(this.intervalfunc)
          }
        }
      );
      r.catch(e=>{
            clearInterval(this.intervalfunc)
              this.completed=true

      })
        // if(this.progress<=100){
        //   this.progress+=5
        // }else{
        // }
      },1500)
    },
    // 取消导入
    cancleProgress(){

        var url=this.urlList[this.type].cancleurl
        clearInterval(this.intervalfunc)
      rejecthttp(true,'get',url+'?handlekey='+this.handleKey,{},this,(doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            // setTimeout(()=>{
            //   this.progress=100
            this.progress=(doc.data.data.progress*100/doc.data.data.total).toFixed(2)
            this.showmodal=false
            this.handleKey=null
            // },10000)

          }else{

          }
        }
      );
    }
    },
    mounted(){
    },
    watch:{

    }
}
</script>

<style scoped>
    .footer{
        text-align: right;
    }
    .result .item{
      display: flex;
      margin: 20px;
    }
</style>


// WEBPACK FOOTER //
// src/components/export-import/exportFile.vue